module.exports = __webpack_public_path__ + "img/organigram-download.a3241b6c.svg";